import { render, staticRenderFns } from "./Headernew.vue?vue&type=template&id=3dde1216&scoped=true&"
import script from "./Headernew.vue?vue&type=script&lang=js&"
export * from "./Headernew.vue?vue&type=script&lang=js&"
import style0 from "./Headernew.vue?vue&type=style&index=0&id=3dde1216&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dde1216",
  null
  
)

export default component.exports